import { useEffect, useState } from 'react'

import { Wrapper } from 'components'
import { TrainingItem } from 'api/types/trainings'
import { trainingService } from 'api/services/trainings'
import { format } from 'date-fns'
import { Card, Spinner, toast } from 'keep-react'

export const Tutorials = () => {
  //first load and is api being called
  const [isLoading, setIsLoading] = useState<boolean>(true)

  // trainings data
  const [data, setData] = useState<TrainingItem[] | null>(null)

  // layout columns
  const [columns, setColumns] = useState<number>(2)

  // fetch training list from API
  const getTrainingList = async () => {
    try {
      const response = (await trainingService.getTrainingList({
        trainingStatus: '2',
      })) as TrainingItem[]
      setData(response || [])
      setIsLoading(false)
    } catch (error) {
      toast.error('Não foi possível carregar as formações.')
    }
  }

  useEffect(() => {
    if (!data) return

    const tutorials = data.filter(training => training.tutorial)

    if (tutorials.length <= 3) {
      setColumns(2)
      return
    }

    if (tutorials.length === 3) {
      setColumns(3)
      return
    }

    if (tutorials.length === 4) {
      setColumns(4)
      return
    }

    setColumns(4)
  }, [data])

  // initial data fetch
  useEffect(() => {
    getTrainingList()
  }, [])
  return (
    <div className="w-full flex-1 py-12 overflow-auto">
      <Wrapper>
        <h1 className="pb-10 text-xxxl font-medium text-primary-600 flex items-center justify-between">
          Tutoriais
        </h1>

        {isLoading || !data ? (
          <Card className="p-4 w-full max-w-full">
            <Spinner color="primary" className="mx-auto" />
          </Card>
        ) : (
          <div
            className={`grid grid-cols-${columns} items-start justify-start flex-wrap gap-4`}
          >
            {data &&
              data.map((training: TrainingItem, index: number) => (
                <Card
                  key={`training${index}`}
                  className="block w-full rounded-2xl max-w-none"
                >
                  <img
                    className="w-full h-auto max-h-[260px] block object-cover object-center rounded-xl"
                    src={`https://img.youtube.com/vi/${training.conferenceVideo}/maxresdefault.jpg`}
                    alt={training.name}
                  />
                  <div className="flex flex-col px-6 py-5 space-y-4">
                    <h3 className="text-body-1 uppercase text-metal-900 tracking-wider">
                      {training.name}
                    </h3>
                    <p className="text-metal-600 text-body-4 tracking-tight">
                      {format(
                        new Date(training.date ?? new Date()),
                        'dd/MM/yyyy HH:mm',
                      )}{' '}
                      {training.teacher}
                    </p>
                    <p className="text-metal-600 text-body-4 tracking-tight">
                      {training.description}
                    </p>
                    <a
                      href={`https://www.youtube.com/watch?v=${training.conferenceVideo}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary-600 underline text-body-4 font-medium"
                    >
                      Ver vídeo
                    </a>
                  </div>
                </Card>
              ))}
          </div>
        )}
      </Wrapper>
    </div>
  )
}
